// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-bottom-sheet {
  /* Custom styles for terms bottom sheet if needed */
}

.terms-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 0 16px 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.terms-text {
  line-height: 1.6;
  color: var(--color-text-primary);
  padding-right: 8px;
}

.terms-text strong {
  color: var(--color-text-primary);
  font-weight: 600;
}

.terms-text br {
  margin-bottom: 8px;
}

.terms-footer {
  padding: 16px 0 0 0;
  border-top: 1px solid var(--color-border);
  margin-top: 16px;
  flex-shrink: 0;
}

.close-button {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/bottomdrawers/TermsBottomSheet.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".terms-bottom-sheet {\n  /* Custom styles for terms bottom sheet if needed */\n}\n\n.terms-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 0 16px 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.terms-text {\n  line-height: 1.6;\n  color: var(--color-text-primary);\n  padding-right: 8px;\n}\n\n.terms-text strong {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.terms-text br {\n  margin-bottom: 8px;\n}\n\n.terms-footer {\n  padding: 16px 0 0 0;\n  border-top: 1px solid var(--color-border);\n  margin-top: 16px;\n  flex-shrink: 0;\n}\n\n.close-button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
